import {DNA} from "react-loader-spinner";
import "./loader.css";

interface LoaderProps {
    size?: number;
    isFullPage?: boolean;
    label?: string;
}

const Loader = ({ size = 120, isFullPage = true, label = '' }: LoaderProps) => {
    return <div className={`loader-container-box ${isFullPage ? 'full-page' : ''}`}>
        <DNA
            visible={true}
            height={size}
            width={size}
            ariaLabel="dna-loading"
            wrapperStyle={{}}
            wrapperClass="dna-wrapper"
        />
        {label && <div className="label">{label}</div>}
    </div>
}

export default Loader;